<template>
    <a-modal :title="`相关附件`" :width="1000" :open="true" @cancel="cancel">
        <template #footer>
            <a-button @click="cancel">取消</a-button>
            <a-popconfirm title="是否确定？" @confirm="onFormSubmit">
                <a-button type="primary" :loading="state.submitLoading">确定</a-button>
            </a-popconfirm>
        </template>
        <a-skeleton :loading="state.loading" active :paragraph="{ rows: 10 }">
            <a-form ref="ruleForm" :model="formData" v-bind="formLayout" v-if="state.log">
                <a-form-item label="类型" name="type" required>
                    <a-tag v-if="state.log.type == 1" color="green">收入</a-tag>
                    <a-tag v-if="state.log.type == 2" color="blue">支出</a-tag>
                </a-form-item>
                <a-form-item label="金额" name="amount" required>
                    {{ state.log.amount }} 元
                </a-form-item>
                <a-form-item label="流水发生时间" required>
                    {{ state.log.amount_time }}
                </a-form-item>
                <a-form-item label="记录时间" required>
                    {{ state.log.created_at }}
                </a-form-item>
                <a-form-item label="备注" required>
                    {{ state.log.remark }}
                </a-form-item>
                <a-form-item label="附件" name="attachment">
                    <template v-for="(item, index) in state.log.attachment">
                        <a-image
                            v-if="item.url.endsWith('png') || item.url.endsWith('jpg') || item.url.endsWith('jpeg')"
                            :width="60" :height="60" :key="index"
                            :src="$store.state.user.image_domain + item.url"></a-image>
                        <a :href="$store.state.user.image_domain + item.url" target="_blank" v-else>
                            {{ item.name }}
                        </a>
                    </template>
                </a-form-item>
                <a-form-item label="关联行为" name="source_type">
                    {{ state.log.source_type_name }}
                </a-form-item>
                <a-form-item label="关联附件" name="source_attachment">
                    <template v-for="(item, index) in state.log.source_attachment">
                        <a-image
                            v-if="item.url.endsWith('png') || item.url.endsWith('jpg') || item.url.endsWith('jpeg')"
                            :width="60" :height="60" :key="index"
                            :src="$store.state.user.image_domain + item.url"></a-image>
                        <a :href="$store.state.user.image_domain + item.url" target="_blank" v-else>
                            {{ item.name }}
                        </a>
                    </template>
                </a-form-item>
            </a-form>
        </a-skeleton>
    </a-modal>
</template>

<script lang="ts" setup>
import { message, Modal } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { reactive, onMounted, ref } from 'vue'
import Upload from '@/components/base/Upload.vue'
import dayjs from 'dayjs'
import { useStore } from 'vuex'
const $store = useStore()
const format = 'YYYY-MM-DD HH:mm:ss'
const formLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
    }
}
const ruleForm = ref()
const emit = defineEmits(['cancel', 'ok'])
const props = defineProps({
    detailData: {
        type: Object,
        default: () => { }
    }
})
interface IState {
    loading: boolean
    submitLoading: boolean
    log: any
}
const state = reactive<IState>({
    loading: false,
    submitLoading: false,
    log: null
})
interface IformData {
}
const formData = reactive<IformData>({
})
onMounted(() => {
    queryDetail()
})
const queryDetail = () => {
    state.loading = true
    let requestParam = {
        url: '/admin/v1/pettycash/logdetail',
        method: 'post',
        data: {
            id: props.detailData.id
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            state.log = res.data
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
            state.loading = false
        })
}

// 提交
const onFormSubmit = () => {
    emit('ok')
}
const cancel = () => {
    emit('cancel')
}
</script>

<style lang="less" scoped></style>
